var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.viewAllPartners)?_c('list-all-customers'):_c('list-customers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }